import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})

export class LocalStorageService {

  constructor() { }


  setItem<T>(key: string, value: T) {
    localStorage.setItem(key, JSON.stringify(value));
  }


  getItem<T>(key: string): T {
    return JSON.parse(localStorage.getItem(key) || '{}');
  }

  setSessionItem<T>(key: string, value: T) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  getSessionItem<T>(key: string): T | null {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }
}
